import { render, staticRenderFns } from "./MergeTool.vue?vue&type=template&id=752230b2"
import script from "./MergeTool.vue?vue&type=script&lang=js"
export * from "./MergeTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports